import { render, staticRenderFns } from "./DailyRoyaltyIncentive.vue?vue&type=template&id=30217f4c&"
import script from "./DailyRoyaltyIncentive.vue?vue&type=script&lang=js&"
export * from "./DailyRoyaltyIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports